export default __webpack_public_path__ + "static/media/icon_check.f306c526.png";